import React, {useCallback, useContext, useEffect, useState} from "react";
import {
    TokenContext,
    RealmContext,
    ProfileContext,
} from "../../Store";

import { makeStyles } from "@mui/styles";
import BimProfileService from "../../../services/BimProfileService";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import {trackPromise} from "react-promise-tracker";
import UserService from "../../../services/UserService";
import BimetaProfilesListView from "./BimetaProfilesListView";


const useStyles = makeStyles({
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },
});


function BimetaProfiles() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const [bimetaProfiles, setBimetaProfiles] = useState([]);
    const profile = useContext(ProfileContext);
    const setBimProfileSelected = profile.setSelected;
    const setBimProfileSelectedData = profile.setSelectedData;

    const classes = useStyles();

    useEffect(() => {
        if (!UserService.isLoggedIn()) {
            UserService.doLogout();
        }
    }, []);

    const GetProfilesData = useCallback(async () => {
        try {
            const res = await trackPromise(BimProfileService.getBimetaProfiles(token, realm));
            if (res.data) setBimetaProfiles(res.data);
            setBimProfileSelected('');
            setBimProfileSelectedData([]);
        } catch (e) {
            console.error("Fehler beim Laden der Bimeta-Profile:", e);
        }
    }, [setBimetaProfiles, setBimProfileSelected, setBimProfileSelectedData, realm, token]);

    useEffect(() => {
        trackPromise(GetProfilesData());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const addNew = async (rowData) => {
        try {
            const res = await trackPromise(BimProfileService.importBimetaProfiles(token, realm, rowData.id));
            if (res.data) setBimetaProfiles(res.data);
        } catch (e) {
            console.error("Fehler beim Importieren der Bimeta-Profile:", e);
        }
    };

    return (
        <div>
            <LoadingIndicator />
            <div className={classes.katalogView}>
                <div className={classes.btListe}>
                    <BimetaProfilesListView
                        profileList={bimetaProfiles}
                        GetProfilesData={GetProfilesData}
                        addNew={addNew}
                    />
                </div>
            </div>
        </div>
    );
}

export default BimetaProfiles;
